export default {
  development: {
    version: 37,
    insights: true,
    quickSearchPerson: true,
    marketMap: true,
    searchByType: true,
    projects: true,
    dealbook: true,
    marketInsight: true,
    dealHistory: true,
    shareProject: true,
    newProfile: true,
    dit: true,
    afdb: true,
    watih: true,
    finsoughtFilter: true,
    futureInterest: true,
    cipe: true,
  },
  test: {
    version: 37,
    insights: true,
    quickSearchPerson: true,
    marketMap: true,
    searchByType: true,
    projects: true,
    dealbook: true,
    marketInsight: true,
    dealHistory: true,
    shareProject: true,
    newProfile: true,
    dit: true,
    afdb: true,
    watih: true,
    finsoughtFilter: true,
    futureInterest: true,
    cipe: true,
  },
  staging: {
    version: 37,
    insights: true,
    quickSearchPerson: true,
    marketMap: true,
    searchByType: true,
    projects: true,
    dealbook: true,
    marketInsight: true,
    dealHistory: true,
    shareProject: true,
    newProfile: true,
    dit: true,
    afdb: true,
    watih: true,
    finsoughtFilter: true,
    futureInterest: true,
    cipe: true,
  },
  production: {
    version: 40,
    insights: true,
    quickSearchPerson: true,
    marketMap: true,
    searchByType: false,
    projects: true,
    dealbook: true,
    marketInsight: true,
    dealHistory: true,
    shareProject: true,
    newProfile: true,
    dit: true,
    afdb: true,
    watih: true,
    finsoughtFilter: true,
    futureInterest: true,
    cipe: true,
  },
}
